export default [
  {
    path: '',
    name: 'facturacion-compra',
    component: () => import(/* webpackChunkName: "facturacion-compra" */ '@/apps/facturacion_compra/pages/FacturacionCompraDashboardPage.vue')
  },
  {
    path: '/facturacion-compra-providers',
    name: 'facturacion-compra-providers',
    component: () => import('@/apps/facturacion_compra/pages/ManageProvidersPage.vue')
  },

  {
    path: '/facturacion-compra-providers-reglas',
    name: 'facturacion-compra-providers-reglas',
    component: () => import('@/apps/facturacion_compra/pages/ReglasProveedor.vue')
  },

  {
    path: '/facturacion-compra-manage-dte',
    name: 'facturacion-compra-manage-dte',
    component: () => import('@/apps/facturacion_compra/pages/ManageDtesPage.vue')
  },
  {
    path: '/facturacion-compra-trasferencia',
    name: 'facturacion-compra-trasferencia',
    component: () => import('@/apps/facturacion_compra/pages/ManageTransferenciaPage.vue')
  },
  {
    path: '/transferencia-electronica',
    name: 'transferencia-electronica',
    component: () => import('@/apps/facturacion_compra/pages/ManageTransferenciaClientePage.vue')
  }

]
